<template>
    <div id="vis">
        <div class="container">
            
                    <div class="list-group container row">

                      <div class="vertical-center list-group-item col-md-6 infobox-not-sci">&nbsp;&nbsp;<b>Brighter color</b> → less <b>scientific articles</b> contain a given word&nbsp;&nbsp;</div>
                       <div class="list-group-item col-md-6 infobox-sci"><b>Darker color</b> → more <b>scientific articles</b> contain a given word</div>
                      <div class="list-group-item col-md-12"><b>Bigger bubble</b>  →  more <b>news articles</b> contain a given word</div>
                    </div>
           
                    <bubble-chart chart-id="chart2" ref="chart_full" :chartData="chart_data" :options="options"></bubble-chart>
        </div>
    </div>
</template>

<style>
.vis-nav-custom {
  display: none;
}

#chart2 {
  /*width: 1140px;*/
  height: 770px !important;
}

@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) { 
    #chart2 { 
        /*width: 1140px !important;*/
        height: 770px !important;
    }
}

@media (-webkit-min-device-pixel-ratio: 3), (min-resolution: 288dpi)  { 
    #chart2 { 
        /*width: 1140px !important;*/
        height: 770px !important;
    }
}
</style>

<script>
import europesocial from '../assets/europesocial_11.json';
import BubbleChart from './BubbleChart.js';

// console.log('europesocial');

export default {
  name: 'vis',
  data () {
    return {
      set_name: 'europesocial',
      chart_data: {'datasets': europesocial},
      options: {
        animation: {
          duration: 5000,

        },
        layout: {
            padding: {
                left: 0,
                right: 50,
                top: 0,
                bottom: 50
            },
        },
        scales: {
          xAxes: [{
            position: 'top',
              scaleLabel: {
                display: true,
                // padding: 50,
                labelString: '← technology   |   society →',
                // labelString: '← technology                         society →',
                // labelString: '← 💾 more technological | more social 📢 →',
                // labelString: '← 💾 | 📢 →',
                fontSize: 24,
                fontFamily: '"Open Sans", sans-serif',
                fontColor: '#3c3950',
              },
            gridLines: {
              drawBorder: false,
                display: false,
            },
            ticks: {
                display: false
            }
          }],
          yAxes: [
          {
            position: 'top',
              scaleLabel: {
                display: true,
                padding: 25,
                labelString: '← United States   |   European Union →',
                // labelString: '← United States                         European Union →',
                // labelString: '← 🇺🇸 more American | more European 🇪🇺 →',
                // labelString: '← 🇺🇸 | 🇪🇺 →',
                fontSize: 24,
                fontFamily: '"Open Sans", sans-serif',
                fontColor: '#3c3950',
              },
            gridLines: {
                drawBorder: false,
              display: false
            },
            ticks: {
                display: false
            }
          }]
        },
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, d) {
                    // return JSON.stringify(tooltipItem);
                    return d.datasets[tooltipItem.datasetIndex].label
                }
          },
          bodyFontSize: 32,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    }
  },
  components: {
    BubbleChart
  },
}


Chart.plugins.register({
  afterDatasetsDraw: function(chart, easing) {
    var ctx = chart.ctx;

    chart.data.datasets.forEach(function(dataset, i) {
      var meta = chart.getDatasetMeta(i);
      if (meta.type == "bubble") { //exclude scatter
        meta.data.forEach(function(element, index) {
          // Draw the text in black, with the specified font
          ctx.fillStyle = 'rgba(60,57,80, 1)';
          // ctx.fillStyle = 'blue';
          // ctx.fillStyle = 'white';
          // ctx.strokeStyle = 'black';
          // ctx.lineWidth = 1;
          // ctx.strokeText(text, x, y);

          var fontSize = 18;
         var fontStyle = 'normal';
          var fontFamily = '"Open Sans", sans-serif';
          ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);

          // Just naively convert to string for now
          var dataString = dataset.data[index].toString();
          // Make sure alignment settings are correct
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';

          var padding = 6;
          var position = element.tooltipPosition();
          ctx.fillText(dataset.title, position.x, position.y - (fontSize / 2) + padding);
          // ctx.strokeText(dataset.title, position.x, position.y - (fontSize / 2) + padding);
        });
      } //if
    });
  }
});
</script>


// WEBPACK FOOTER //
// src/components/Visualizations.vue